import { EMPTY_FIELD } from 'constants/emptyField';
import { OrderDisputeStatuses } from 'constants/orderDisputeStatuses';

import GavelIcon from '@mui/icons-material/Gavel';
import { fromUnixTime } from 'date-fns';
import { ReferenceManyField } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { DeleteIconButton, IconButton } from 'shared/mui/IconButtons';
import { DateField, TextField } from 'shared/react-admin/Fields';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { ActionsSlots } from 'shared/react-admin/Table/ActionsSlots/ActionsSlots';
import { OrderDispute } from 'types/embedded/orderDispute';

import { StyledDatagrid } from './OrdersShowDisputesList.styled';

type Props = {
  handleOpenEditRecordModal: (record: OrderDispute) => void;
  handleOpenDeleteRecordModal: (record: OrderDispute) => void;
};

export const OrdersShowDisputesList: React.FC<Props> = ({
  handleOpenEditRecordModal,
  handleOpenDeleteRecordModal,
}) => {
  return (
    <ReferenceManyField label={false} reference="order_disputes" target="order">
      <StyledDatagrid
        bulkActionButtons={false}
        empty={<Alert severity="info">Диспуты отсутствуют</Alert>}
      >
        <TextField label="ID" source="originId" />
        <ReferenceField
          label="Статус диспута"
          reference="enum/order_dispute_statuses"
          source="disputeStatus"
        >
          <TextField source="description" />
        </ReferenceField>
        <DateField
          emptyText={EMPTY_FIELD}
          label="Дата открытия"
          source="openedAt"
          transform={(v: number) => fromUnixTime(v)}
        />
        <TextField emptyText={EMPTY_FIELD} label="Причина открытия" source="openReason" />
        <DateField
          emptyText={EMPTY_FIELD}
          label="Дата закрытия"
          source="closedAt"
          transform={(v: number) => fromUnixTime(v)}
        />
        <TextField emptyText={EMPTY_FIELD} label="Причина закрытия" source="closeReason" />
        <ActionsSlots
          render={(record: OrderDispute) => {
            if (record.disputeStatus === OrderDisputeStatuses.Received) {
              return (
                <IconButton onClick={() => handleOpenEditRecordModal(record)} size="small">
                  <GavelIcon fontSize="inherit" />
                </IconButton>
              );
            }
            if (record.disputeStatus === OrderDisputeStatuses.Rejected) {
              return (
                <DeleteIconButton
                  key="delete-button"
                  onClick={() => handleOpenDeleteRecordModal(record)}
                />
              );
            }
            return <></>;
          }}
        />
      </StyledDatagrid>
    </ReferenceManyField>
  );
};
